import { Component, OnInit, Input } from "@angular/core";
import { AtendimentoService } from "src/app/services/actions/atendimento.service";
import { ServerRoutes } from "src/app/ServerRoutes";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
import { ToastrService } from "ngx-toastr";

@Component({
	selector: "app-single-cliente",
	templateUrl: "./single-cliente.component.html",
	styleUrls: ["./single-cliente.component.scss"],
})
export class SingleClienteComponent implements OnInit {
	@Input() id;
	user = { image: "", idiomas: "" };
	atendimentos = [];
	paginaAtual = 1;
	limitePorPagina = 20;
	atendimentoSelecionado = { id: "", comentarioAtendimento: "" };

	constructor(
		private atendimentoService: AtendimentoService,
		private routes: ServerRoutes,
		private toastr: ToastrService
	) {}

	ngOnInit() {
		this.getAtendimentos();
	}

	getAtendimentos() {
		this.atendimentoService
			.getAtendimentosUser(
				this.id,
				(this.paginaAtual - 1) * 20,
				this.limitePorPagina
			)
			.subscribe(
				(res) => {
					console.log(res);
					this.user = res["user"];
					this.atendimentos[this.paginaAtual] = res["atendimentos"];

					if (this.user.image) {
						this.user.image =
							this.routes.server +
							"/client/photos/perfil/cliente/" +
							this.user.image;
					} else {
						this.user.image =
							this.routes.server +
							"/client/photos/perfil/cliente/random.png";
					}

					if (this.user.idiomas) {
						this.user.idiomas = JSON.parse(this.user.idiomas);
					}
				},
				(err) => {}
			);
	}

	addPagina(number) {
		this.paginaAtual += number;
		if (!this.atendimentos[this.paginaAtual]) {
			this.getAtendimentos();
		}
	}

	selecionarAtendimento(atendimento) {
		this.atendimentoSelecionado = atendimento;
	}

	comentarAtendimento() {
		this.atendimentoService
			.comentarAtendimento(
				this.atendimentoSelecionado.id,
				this.atendimentoSelecionado.comentarioAtendimento
			)
			.subscribe(
				(res) => {
					this.toastr.success("Comentário atualizado com sucesso");
				},
				(err) => {
					this.toastr.error("Tente novamente mais tarde", "Erro");
				}
			);
	}
}
